module.exports = "data:image/gif;base64,R0lGODlhGwAFAJEAAMXFxfX19enu7gAAACH5BAAAAAAALAAAAAAbAAUAAAIRjI6pixDGYnRQ2vauFnRfVwAAOw=="